import React from 'react';

import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {PredictionsWidgetController} from "../predictions-widget.controller";
import {PredictionsWidgetProps} from "../models/predictions-widget.props";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";
import {APP} from "../../../core/app/consts";
import {PredictionPlaceholder} from "../../../core/components/prediction/components/placeholder/prediction.placeholder";
import {PredictionWidgetCards} from "./prediction-widget.cards";
import {Loader} from "../../../core/components/loading/loader";
import {PredictionWidgetTabs} from "./prediction-widget.tabs";
import {PredictionWidgetDetailsPopup} from "./prediction-widget.details-popup";
import styles from "../styles/prediction-widget.module.scss";
import classNames from "classnames";

export class PredictionsWidgetComponentProps extends PredictionsWidgetProps {}

export const PredictionsWidgetComponent = ({controller}: PredictionsWidgetComponentProps) => {
  const {state, terms, device} = controller;
  const {isSmallView} = device;
  const {WEB_GC_PREDICTIONS_TITLE} = terms;
  const {selectedTab, sportTypeId, currentContext} = state;

  const widgetCardWrapperProps = {
    controller,
    title: WEB_GC_PREDICTIONS_TITLE,
    source: APP.ANALYTICS.SOURCES.predictions,
    sportTypeId,
    className: classNames({[styles.small_view]: isSmallView})
  }

  const betsImpressionParams = {
    bookieId: currentContext?.selectedCard?.odds?.bookmaker.id,
    bookieName: currentContext?.selectedCard?.odds?.bookmaker.name,
    subSource: selectedTab?.analyticsLabel,
    sportTypeId,
  }

  const predictionProps = {
    controller,
    betsImpressionParams
  }

  const loaderProps = {
    when: state.fetchingState === FETCHING_STATES.fetching || state.componentState === COMPONENT_STATES.loading,
    Component: PredictionPlaceholder,
  };

  return (
    <Loader {...loaderProps}>
      <WidgetWrapper {...widgetCardWrapperProps}>
        <PredictionWidgetTabs controller={controller}/>
        <PredictionWidgetCards {...predictionProps}/>
        <PredictionWidgetDetailsPopup controller={controller} source={APP.ANALYTICS.SOURCES.predictions}/>
      </WidgetWrapper>
    </Loader>
  )
}

const settings: ComposeSettings = {
  component: PredictionsWidgetComponent,
  propsType: PredictionsWidgetComponentProps,
  controllerType: PredictionsWidgetController,
  LoaderComponent: (props) => <PredictionPlaceholder {...props}/>,

  createModule: true,
  observe: true,
}

export default Compose(settings);
